import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useOnScreen } from 'hooks';
import { Tooltip } from '@mui/material';
import { Warning, ArrowUpward } from '@mui/icons-material';
import { GoToWarningsFab, WarningsAnchor, WarningsContainer, WarningsWrapper } from '../../PolicyRenewalStyles';

const PolicyRenewalActionWarningsComponent = ({ warningsSummary }) => {
  const [t] = useTranslation();

  const [warnings, setWarnings] = useState([]);
  const containerRef = useRef();
  const anchorRef = useRef();

  const isVisible = useOnScreen(containerRef);

  useEffect(() => {
    const newWarnings = [];
    if (warningsSummary.hasOfferWarning) newWarnings.push(t('Offer.PolicyRenewalList.Warnings.Offer'));
    if (warningsSummary.hasQuotationsWarning) newWarnings.push(t('Offer.PolicyRenewalList.Warnings.IncompleteOffer'));
    if (warningsSummary.hasSentToClientWarning) newWarnings.push(t('Offer.PolicyRenewalList.Warnings.SentToClient'));
    setWarnings(newWarnings);
  }, [warningsSummary, t]);

  const goToWarnings = useCallback(() => anchorRef.current?.scrollIntoView({ behavior: 'smooth' }), []);

  return (
    <>
      <WarningsWrapper ref={containerRef} empty={warnings.length === 0}>
        <WarningsAnchor ref={anchorRef} />
        {warnings.length > 0
          ? warnings.map((warning, index) => (
              <WarningsContainer key={index}>
                <Warning id={`warning_${index}`} />
                <span>{warning}</span>
              </WarningsContainer>
            ))
          : null}
      </WarningsWrapper>
      {!isVisible && warnings.length > 0 && (
        <Tooltip title={t('Offer.PolicyRenewalList.Warnings.Button')}>
          <GoToWarningsFab aria-label='goToWarnings' color='warning' size='medium' onClick={goToWarnings}>
            <ArrowUpward />
          </GoToWarningsFab>
        </Tooltip>
      )}
    </>
  );
};

PolicyRenewalActionWarningsComponent.propTypes = {
  warningsSummary: PropTypes.object
};

export default PolicyRenewalActionWarningsComponent;
